<template>
        <div class="container mt-5">
            <div id="notfound">
                <div class="notfound">
                    <div class="notfound-404">
                        <h1 class="ttl404"><!-- {{$t('404')}}--></h1>
                    </div>
                    <h2>{{$t('NotFound')}}</h2>
                    <p>{{$t('You can either return to the previous page or visit our homepage. Return to homepage')}} </p>
                    <p><router-link to="/">{{$t('Return to homepage')}}</router-link></p>

                </div>
            </div>
        </div>
</template>

<script>
export default {
    metaInfo: {
        title: '404 Page Not Found',
        meta: [
            {name: 'description', content: 'This is 404 not found page'}
        ]
    },
    methods:{
        reloadPage(path = '/') {
            window.location.href = path;
        }
    }
}
</script>
<style scoped>
#notfound .notfound{
    margin: 0 auto;
}
.notfound{max-width:767px;width:100%;line-height:1.4;text-align:center;padding:15px}
.notfound .notfound-404{position:relative;}
.notfound .notfound-404 h1{
/*     position:absolute;
    left:50%;
    top:50%;
    -webkit-transform:translate(-50%,-50%);
    -ms-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
    font-size:186px;
    font-weight:200;
    margin:0;
    background: linear-gradient(130deg,#90c7e7,#00abe5);
    color:transparent;
    -webkit-background-clip:text;
    background-clip:text;
    text-transform:uppercase
  */
}
.notfound h2{font-size:33px;font-weight:200;text-transform:uppercase;margin-top:0;margin-bottom:25px;letter-spacing:3px}
.notfound p{font-size:16px;font-weight:200;margin-top:0;margin-bottom:25px}
.notfound a{
    color:#00abe5;font-weight:200;text-decoration:none;border-bottom:1px dashed #00abe5;border-radius:2px
}
@media only screen and (max-width:480px){
    .notfound .notfound-404 {
        position:relative;
    }
    .notfound .notfound-404 h1{
        font-size:142px
    }
    .notfound h2{
        font-size:22px
    }
}
</style>